import CategoriesList from './CategoriesList';
import CategoryItem from './CategoryItem';

export {
  CategoriesList,
  CategoryItem,
};



// WEBPACK FOOTER //
// ./src/components/Categories/index.js